<div class="row d-flex flex-row mt-5 bg-gray-200 rounded mb-2 dark:bg-coal-700">
  <span class="text-2sm font-medium text-gray-900 p-4">{{
    activeModalContext?.labelText
  }}</span>
</div>
